import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import { stylePropType, TSS_GREEN_1 } from 'tss-core-lib-common';

var styles = void 0;

var Loading = function Loading(_ref) {
  var style = _ref.style,
      fill = _ref.fill;
  return React.createElement(
    'div',
    { className: css(styles.container, fill && styles.fill, style) },
    React.createElement(
      'div',
      { className: css(styles.circle, style) },
      React.createElement(
        'div',
        { className: css(styles.inner) },
        React.createElement(
          'svg',
          {
            width: '113px',
            height: '117px',
            viewBox: '0 0 113 117',
            version: '1.1',
            xmlns: 'http://www.w3.org/2000/svg'
          },
          React.createElement(
            'g',
            { id: 'icon icon-tss-logo-paths', stroke: 'none', strokeWidth: '1', fill: '#99DC00', fillRule: 'nonzero' },
            React.createElement(
              'g',
              { transform: 'translate(23.000000, 13.000000)' },
              React.createElement(
                'g',
                { transform: 'translate(-8.000000, 3.000000)' },
                React.createElement('path', {
                  d: 'M42.9932328,0 L85.5,30.710609 L69.2967672,81 L0,31.2911219 L42.999375,0 L42.9932328,0 Z M84.1155388,31.1570628 L42.9932328,1.47465039 L2.04905172,31.2468455 L68.6678017,79.0333895 L84.1155388,31.1570628 L84.1155388,31.1570628 Z',
                  className: css(styles.iconTssLogoPathsAnimation, styles.iconTssLogoPaths1)
                }),
                React.createElement('path', {
                  d: 'M16.134964,9 L85.5,31.2856625 L42.8615915,90 L0,58.9964948 L16.1331195,9 L16.134964,9 Z M83.5774289,31.9526414 L17.1174612,10.3780152 L1.6852103,58.5516382 L42.5480286,88.3086883 L83.5774289,31.9520295 L83.5774289,31.9526414 Z',
                  className: css(styles.iconTssLogoPathsAnimation, styles.iconTssLogoPaths2)
                }),
                React.createElement('path', {
                  d: 'M69.1849381,9 L85.5,59.0647345 L42.7496934,90 L0,31.9021219 L69.1849381,9 L69.1849381,9 Z M84.0742335,58.6202465 L68.3828295,10.5080843 L1.91757934,32.4778804 L43.0176762,88.2690612 L84.0736202,58.6202465 L84.0742335,58.6202465 Z',
                  className: css(styles.iconTssLogoPathsAnimation, styles.iconTssLogoPaths3)
                }),
                React.createElement('path', {
                  d: 'M67.5,9 L67.5,81 L18,81 L18,9 L67.5,9 Z M66.375794,79.8475127 L66.375794,10.1951269 L19.1253514,10.1951269 L19.1253514,79.8475127 L66.375794,79.8475127 Z',
                  className: css(styles.iconTssLogoPathsAnimation, styles.iconTssLogoPaths3)
                })
              )
            )
          )
        )
      )
    )
  );
};

Loading.propTypes = {
  style: stylePropType,
  fill: PropTypes.bool
};

Loading.defaultProps = {
  style: null,
  fill: true
};

var keyframes = {
  '0%': {
    transform: 'rotate(0deg) scale(1)'
  },

  '50%': {
    transform: 'rotate(180deg) scale(0.7)'
  },

  '100%': {
    transform: 'rotate(360deg) scale(1)'
  }
};

styles = StyleSheet.create({
  container: {},

  fill: {
    position: 'fixed',
    zIndex: 1000,
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  circle: {
    width: '12rem',
    height: '12rem',
    backgroundColor: TSS_GREEN_1(),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%'
  },

  inner: {
    position: 'relative',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
    animationDirection: 'normal',
    animationDuration: '1.6s',
    animationName: [keyframes]
  },

  iconTssLogoPathsAnimation: {
    animationDuration: '3s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
    animationFillMode: 'both',
    animationDirection: 'normal',
    transformOrigin: 'center center'
  }
});

export default Loading;